import { AdminLocaleProvider, useAdminLocale } from "@/context/AdminLocaleContext";
import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";

export default function AdminProtectedRoute({ children }) {
  return <AdminLocaleProvider><AdminGuard>{children}</AdminGuard></AdminLocaleProvider>;
}

function AdminGuard({ children }) {
  const { tAdmin } = useAdminLocale();
  const { isAuthenticated, loading } = useAdminAuth();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-levami-charbon text-levami-creme text-sm">{tAdmin("dashboard.loading", "Chargement...")}</div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/admin/connexion" replace />;
  }
  return children;
}
